var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMhsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.153,
    height: 131.348,
    viewBox: "0 0 297.153 131.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ROOFING",
    transform: "translate(40.6 127.348)",
    fill: "currentColor",
    fontSize: 18,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ROOFING")), /*#__PURE__*/React.createElement("text", {
    id: "SOLAR",
    transform: "translate(154.224 127.29)",
    fill: "currentColor",
    fontSize: 18,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SOLAR")), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 13.727,
    transform: "translate(144.752 114.752)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(42.09 72.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M158.335,165.82h5.507v3.648c1.548-2.143,3.642-4.15,7.329-4.15a7.625,7.625,0,0,1,7.192,4.24,9.664,9.664,0,0,1,8.1-4.24c5.234,0,8.421,3.329,8.421,9.211v15.366h-5.508V176.216c0-3.83-1.775-5.882-4.87-5.882-3,0-5.144,2.1-5.144,5.973v13.588h-5.508V176.17c0-3.739-1.821-5.837-4.87-5.837s-5.144,2.28-5.144,5.973v13.588h-5.507Z",
    transform: "translate(-158.335 -159.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M217.5,177.994V177.9a12.816,12.816,0,0,1,25.626-.091v.091a12.576,12.576,0,0,1-12.881,12.539A12.44,12.44,0,0,1,217.5,177.994Zm20.119,0V177.9a7.436,7.436,0,0,0-7.374-7.751c-4.415,0-7.237,3.465-7.237,7.661v.091a7.415,7.415,0,0,0,7.328,7.706C234.8,185.609,237.623,182.143,237.623,177.994Z",
    transform: "translate(-175.677 -159.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M261.576,165.82h5.508v3.648c1.547-2.143,3.642-4.15,7.328-4.15a7.625,7.625,0,0,1,7.192,4.24,9.664,9.664,0,0,1,8.1-4.24c5.234,0,8.42,3.329,8.42,9.211v15.366h-5.507V176.216c0-3.83-1.775-5.882-4.871-5.882-3,0-5.144,2.1-5.144,5.973v13.588H277.1V176.17c0-3.739-1.821-5.837-4.87-5.837s-5.144,2.28-5.144,5.973v13.588h-5.508Z",
    transform: "translate(-188.602 -159.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M320.746,177.948v-.091c0-6.885,4.87-12.539,11.743-12.539,7.647,0,11.516,6.019,11.516,12.949,0,.5-.045,1-.091,1.55H326.253a6.713,6.713,0,0,0,6.919,6.11,8.722,8.722,0,0,0,6.509-2.872l3.231,2.872a12.147,12.147,0,0,1-9.832,4.514C326.117,190.442,320.746,185.38,320.746,177.948Zm17.8-1.778c-.364-3.556-2.458-6.338-6.1-6.338-3.368,0-5.735,2.6-6.236,6.338Z",
    transform: "translate(-205.934 -159.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M361.412,165.82h5.508v3.693a8.708,8.708,0,0,1,7.51-4.2c5.417,0,8.557,3.648,8.557,9.211v15.366H377.48V176.216c0-3.739-1.866-5.882-5.144-5.882-3.186,0-5.416,2.234-5.416,5.973v13.588h-5.508Z",
    transform: "translate(-217.849 -159.208)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M401.6,180.738V168.063h-3.049v-4.742H401.6v-6.612H407.1v6.612h6.464v4.742H407.1v11.809c0,2.143,1.093,3.009,2.959,3.009a7.393,7.393,0,0,0,3.414-.82v4.514a9.512,9.512,0,0,1-4.962,1.231C404.463,187.805,401.6,186.027,401.6,180.738Z",
    transform: "translate(-228.722 -156.709)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M427.263,181.345v-15.32h5.507V179.7c0,3.739,1.867,5.836,5.144,5.836,3.186,0,5.416-2.189,5.416-5.927V166.025h5.553V190.1H443.33V186.36a8.644,8.644,0,0,1-7.51,4.241C430.4,190.6,427.263,186.954,427.263,181.345Z",
    transform: "translate(-237.148 -159.413)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M467.48,165.82h5.507v3.648c1.548-2.143,3.642-4.15,7.329-4.15a7.625,7.625,0,0,1,7.192,4.24,9.664,9.664,0,0,1,8.1-4.24c5.234,0,8.42,3.329,8.42,9.211v15.366h-5.508V176.216c0-3.83-1.775-5.882-4.87-5.882-3,0-5.144,2.1-5.144,5.973v13.588H483V176.17c0-3.739-1.821-5.837-4.871-5.837s-5.144,2.28-5.144,5.973v13.588H467.48Z",
    transform: "translate(-248.967 -159.208)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M130.535,104.23V87.643H118.02v23.572L98.928,121.869V134.7L219.97,67.493V54.321Z",
    transform: "translate(-98.928 -54.321)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M370.485,102.3v12.834L269.772,67.493V54.321Z",
    transform: "translate(-149.046 -54.321)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M362.345,92.809l-76.7-36.286-.973,2.063,12.954,6.129-.6,1.161,2.055.986.605-1.172,47.807,22.617-.589,1.329,2.058.982.593-1.336,11.817,5.59Z",
    transform: "translate(-153.381 -54.96)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhsLogo);
export default __webpack_public_path__ + "static/media/MHSLogo.404fc346e3cef22ddcbc70c9908794a5.svg";
export { ForwardRef as ReactComponent };